var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGibraltar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52793)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.0342C24.8366 32.0342 32 24.8707 32 16.0342C32 7.19762 24.8366 0.0341797 16 0.0341797C7.16344 0.0341797 0 7.19762 0 16.0342C0 24.8707 7.16344 32.0342 16 32.0342Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 32.0342C22.8792 32.0342 28.744 27.6922 31.0046 21.5994H0.994995C3.25575 27.6922 9.12037 32.0342 15.9999 32.0342Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2607 13.2519V11.165H22.9563V9.77364H21.565V10.4693H20.1738V9.77364H18.7825V11.165H19.4781V13.2519H18.0868V8.38245H18.7825V6.9912H17.3912V7.6867H16.6955V6.9912H15.3042V7.6867H14.6085V6.9912H13.2172V8.38245H13.9129V13.2519H12.5216V11.165H13.2172V9.77364H11.8259V10.4693H10.4347V9.77364H9.04334V11.165H9.73897V13.2519H8.34766V18.8171H23.652V13.2519H22.2607Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 18.1215C14.8474 18.1215 13.913 19.0558 13.913 20.2084C13.913 21.1169 14.4939 21.8896 15.3043 22.1761V25.078H13.2174V27.8606H16.6957V22.1762C17.5061 21.8897 18.087 21.117 18.087 20.2085C18.0869 19.0559 17.1525 18.1215 16 18.1215V18.1215ZM16 20.9041C15.6158 20.9041 15.3043 20.5926 15.3043 20.2085C15.3043 19.8243 15.6158 19.5128 16 19.5128C16.3842 19.5128 16.6956 19.8243 16.6956 20.2085C16.6956 20.5926 16.3842 20.9041 16 20.9041Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52793"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.0341797)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGibraltar);
export default __webpack_public_path__ + "static/media/gibraltar.abe9428b.svg";
export { ForwardRef as ReactComponent };